export default __webpack_public_path__ + "static/mascon_head_blink-76dca00e336bf44d03fbdbf54e37da9c.gif";